export type TNonNullable<T> = {
    [k in keyof T]-?: NonNullable<T[k]>
}

/** Just the workaround, since '@types/lodash-es' doesn't export this type any longer. */
export interface Dictionary<T> {
    [index: string]: T
}

export function toRecords<T extends Record<string, any>, K extends keyof T>(
    array: T[],
    selector: K,
): Record<T[K], T> {
    return array.reduce(
        (acc, item) => ({ ...acc, [item[selector]]: item }),
        {} as Record<T[K], T>,
    )
}

export type PickRequired<T, K extends keyof T> = {
    [P in K]-?: NonNullable<T[P]>
}

/**
 * Type guard to filter out null values.
 */
export const isNotNull = <T>(value: T | null): value is T => value !== null
